module.exports = __webpack_public_path__ + "static/media/inventoryManagementsystem.d0d5651b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Mtech/inventoryManagementsystem.jpg
// module id = 332
// module chunks = 0